import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { FundingBanner, PedalShareShell, TokenForm } from "./PedalSharePage";

/** Accesso al pannello condiviso inserendo il token invece di aprire il link. */
export default function PedalShareCodePage() {
    const { t } = useTranslation();
    return (
        <PedalShareShell>
            <Box sx={{ bgcolor: "#fff", borderRadius: "14px", p: { xs: 2, md: 4 }, maxWidth: 560, mx: "auto" }}>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 2 }}>{t('pedalShareTitle')}</Typography>
                <TokenForm autoFocus />
            </Box>
            <Box sx={{ maxWidth: 940, mx: "auto" }}><FundingBanner /></Box>
        </PedalShareShell>
    );
}
